var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlame2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 19C9.1972 18.9999 7.92475 18.6218 6.84735 17.9147C5.76996 17.2077 4.93731 16.2043 4.45737 15.0346C3.97742 13.8649 3.87233 12.5829 4.1557 11.3549C4.43907 10.1268 5.09784 9.00931 6.0466 8.14726C7.20972 7.08986 10.0664 5.18605 9.63302 1C14.8332 4.34884 17.4334 7.69767 12.2331 12.7209C13.0998 12.7209 14.3999 12.7209 16.5666 10.653C16.8007 11.3002 17 11.9959 17 12.7209C17 14.3862 16.3152 15.9833 15.0961 17.1609C13.8771 18.3385 12.2237 19 10.4997 19Z",
    fill: "currentColor "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame2Icon);
export default __webpack_public_path__ + "static/media/flame2-icon.507b9fa14c5675e335e774014546a72f.svg";
export { ForwardRef as ReactComponent };